import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrophy,
  faStar,
  faSyncAlt,
  faExclamationTriangle,
  faDice,
  faLock,
  faBolt,
  faMicrophone,
  faHourglassHalf,
  faEye,
  faBan,
  faBullseye,
  faTimes,
  faTv,
  faArrowUp,
  faPlay,
  faSquare,
  faCheck,
  faArrowRight,
  faReply,
} from '@fortawesome/free-solid-svg-icons';

export const Icon = ({ name, className = '', size = 'lg' }: {
  name: IconName;
  className?: string;
  size?: 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '5xl' | '6xl' | '7xl' | '8xl';
}) => {
  const sizeMap = {
    xs: 'text-xs',
    sm: 'text-sm',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '5xl': 'text-5xl',
    '6xl': 'text-6xl',
    '7xl': 'text-7xl',
    '8xl': 'text-8xl',
  };

  return (
    <FontAwesomeIcon 
      icon={iconMap[name]} 
      className={`${sizeMap[size]} ${className}`}
      fixedWidth 
    />
  );
};

export type IconName =
  | 'trophy'
  | 'star'
  | 'sync'
  | 'warning'
  | 'dice'
  | 'lock'
  | 'bolt'
  | 'microphone'
  | 'hourglass'
  | 'eye'
  | 'ban'
  | 'target'
  | 'times'
  | 'tv'
  | 'arrowUp'
  | 'play'
  | 'stop'
  | 'check'
  | 'arrowRight'
  | 'reply';

const iconMap: Record<IconName, typeof faTrophy> = {
  trophy: faTrophy,
  star: faStar,
  sync: faSyncAlt,
  warning: faExclamationTriangle,
  dice: faDice,
  lock: faLock,
  bolt: faBolt,
  microphone: faMicrophone,
  hourglass: faHourglassHalf,
  eye: faEye,
  ban: faBan,
  target: faBullseye,
  times: faTimes,
  tv: faTv,
  arrowUp: faArrowUp,
  play: faPlay,
  stop: faSquare,
  check: faCheck,
  arrowRight: faArrowRight,
  reply: faReply,
};
